import { useQuery } from '@tanstack/react-query';
import Api from '../api/Api';
import { IGetDatasetPanelDetails } from '../types/api';
import { QUERY_KEYS } from './queryKeys';

export const useDatasetPanelDetailsQuery = (
  coordinates: number[] | undefined,
  datasetId: string,
  isEnabled = true
) =>
  useQuery<IGetDatasetPanelDetails>({
    queryKey: [QUERY_KEYS.dataset.waterDepth, coordinates, datasetId],
    queryFn: () =>
      Api.detail.getDatasetPanelDetails(coordinates ?? [], datasetId),
    enabled: isEnabled && !!datasetId && !!coordinates,
  });
